export enum DefaultOrientation {
  ALL = 'all',
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export type DefaultOrientationProps = {
  defaultOrientation?: DefaultOrientation;
};
